import React from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import {MemberRegion} from "../regions/MemberRegions";
import AddMember from "./AddMember";

export interface Member {
    member_id: number
    first_name: string
    last_name: string
    owner_number: string
    email: string
    contact_number1: string
    contact_number2: string
    hotel_name: string
    regionId: string
    number_of_rooms: string
    number_of_staffs: string
    registration_date: string
    expiry_date: string
}

const initialMember: Member = {
    contact_number1  : "",
    contact_number2  : "",
    email            : "",
    expiry_date      : "",
    first_name       : "",
    hotel_name       : "",
    last_name        : "",
    member_id        : 0,
    number_of_rooms  : "",
    number_of_staffs : "",
    owner_number     : "",
    registration_date: "",
    regionId         : ""
}

export default function Members() {
    const {showMessage} = useAlert()
    const [members, setMembers] = React.useState<Member[]>([])
    const [regions, setRegions] = React.useState<MemberRegion[]>([])
    const [editMember, setEditMember] = React.useState({show: false, member: initialMember})

    const getMembers = () => {
        Utils.toggleSpinner('show')
        AppApi.getMembers()
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    setMembers(res.data['members'])
                    setRegions(res.data['regions'])
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error while loading members', type: 'error'})
            })
    }

    React.useEffect(() => {
        getMembers()
    }, [])

    return (
        <>
            <div className={'action_container'}>
                <span className={'action_btn'} onClick={() => setEditMember({member: initialMember, show: true})}>Add New</span>
                <span className={'action_btn'} onClick={getMembers}>Load List</span>
            </div>

            <div className="table_container table-responsive">
                <table id="example" className="table table-striped table-sm border w-100">
                    <thead>
                        <tr>
                            <th style={{width: '90px'}}>Hotel Name</th>
                            <th>Hotel Email</th>
                            <th>Owner's Name</th>
                            <th>Owner's Contact</th>
                            <th style={{width: '120px'}}>No. of Rooms</th>
                            <th style={{width: '120px'}}>No. of Staffs</th>
                            <th style={{width: '120px'}}>Reg Date</th>
                            <th style={{width: '120px'}}>Expiry Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            members.map(member =>
                                <tr key={member.member_id} onClick={() => setEditMember({show: true, member: member})}>
                                    <td>{member.email}</td>
                                    <td>{member.hotel_name}</td>
                                    <td dangerouslySetInnerHTML={{__html: `${member.first_name} ${member.last_name}`}}></td>
                                    <td>{member.owner_number}</td>
                                    <td>{member.number_of_rooms}</td>
                                    <td>{member.number_of_staffs}</td>
                                    <td>{member.registration_date}</td>
                                    <td>{member.expiry_date}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

            <AddMember
                show={editMember.show} member={editMember.member} regions={regions}
                close={(aMember) => {
                    if (aMember !== undefined) {
                        if (editMember.member.member_id === 0) {
                            setMembers([aMember, ...members])
                        } else {
                            setMembers(members.map(bMember =>
                                bMember.member_id === aMember.member_id ? aMember : bMember))
                        }
                    }
                    setEditMember({member: initialMember, show: false})
                }}/>
        </>
    )
}